/**
 * RBAC Permissions for D3 Command
 * Admin: Full access
 * Manager: CRUD meetings/tasks/risks, analytics. No settings/user management, no delete tasks.
 * Member: View meetings/tasks, update task status only. No create/delete, no analytics, no settings.
 */

const PERMISSIONS = {
  admin: {
    canViewDashboard: true,
    canViewMeetings: true,
    canCreateMeeting: true,
    canProcessMeeting: true,
    canUploadAudio: true,
    canViewTasks: true,
    canCreateTask: true,
    canEditTask: true,
    canDeleteTask: true,
    canMoveTask: true,
    canViewRisks: true,
    canCreateRisk: true,
    canEditRisk: true,
    canViewAnalytics: true,
    canViewSettings: true,
    canManageUsers: true,
    canManageIntegrations: true,
    canManageApiKeys: true,
    canManageLeads: true,
  },
  manager: {
    canViewDashboard: true,
    canViewMeetings: true,
    canCreateMeeting: true,
    canProcessMeeting: true,
    canUploadAudio: true,
    canViewTasks: true,
    canCreateTask: true,
    canEditTask: true,
    canDeleteTask: false,
    canMoveTask: true,
    canViewRisks: true,
    canCreateRisk: true,
    canEditRisk: true,
    canViewAnalytics: true,
    canViewSettings: false,
    canManageUsers: false,
    canManageIntegrations: false,
    canManageApiKeys: false,
    canManageLeads: false,
  },
  member: {
    canViewDashboard: true,
    canViewMeetings: true,
    canCreateMeeting: false,
    canProcessMeeting: false,
    canUploadAudio: false,
    canViewTasks: true,
    canCreateTask: false,
    canEditTask: false,
    canDeleteTask: false,
    canMoveTask: true, // can update task status
    canViewRisks: true,
    canCreateRisk: false,
    canEditRisk: false,
    canViewAnalytics: false,
    canViewSettings: false,
    canManageUsers: false,
    canManageIntegrations: false,
    canManageApiKeys: false,
    canManageLeads: false,
  },
};

export function getPermissions(role) {
  return PERMISSIONS[role] || PERMISSIONS.member;
}

export function hasPermission(role, permission) {
  const perms = getPermissions(role);
  return perms[permission] === true;
}
